import { useState, useEffect, useRef } from 'react';
import IconSvg from 'src/assets/icons/IconSvg';

interface Props {
  value?: string;
  onChange: (query: string) => void;
  placeholder?: string;
  className?: string;
  debounceMs?: number;
}

const RaffleSearchInput = ({
  value = '',
  onChange,
  placeholder = 'Search raffles',
  className,
  debounceMs = 400,
}: Props) => {
  const [localValue, setLocalValue] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setLocalValue(val);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange(val), debounceMs);
  };

  return (
    <div className={`relative ${className ?? ''}`}>
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-grayscale-400">
        <IconSvg icon="searchM" />
      </div>
      <input
        type="text"
        className="py-2 w-full h-10 text-base rounded-lg bg-grayscale-900 text-brand-magnolia placeholder:text-grayscale-400 pl-11 pr-3 outline-none focus:ring-1 focus:ring-grayscale-700"
        placeholder={placeholder}
        value={localValue}
        onChange={handleChange}
        autoComplete="off"
      />
    </div>
  );
};

export default RaffleSearchInput;
